import React, { Component } from 'react';import PropTypes from 'prop-types';

export default class ReadMore extends Component {
  
  state = { more: false }

  onToggle = () => {
    this.setState( { more : !this.state.more } )
  }

  render = () => {
    var style = !this.state.more ? {maxHeight: this.props.height } : {}
    var text = !this.state.more ? '▾ Läs mer':' ▴ Dölj'
    return (
      <div  className="readmore">
        <div className="readmore__content" style={ style }>
          {this.props.children}
        </div>
        <a onClick={this.onToggle}>{ text }</a>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Formaters/ReadMore.jsx